import api from '../api';
import type { InventorySample } from '../../types/inventory';
import { mapDtoToInventorySample } from './inventoryMappers';

export const inventorySamplesService = {
  getSamples: async (itemId: string): Promise<InventorySample[]> => {
    try {
      const response = await api.get(`/samples/item/${itemId}`);
      const data = response.data || [];
      return Array.isArray(data) ? data.map(mapDtoToInventorySample) : [];
    } catch (error) {
      console.error('Error fetching samples:', error);
      return [];
    }
  },

  createSample: async (itemId: string, date: string, notes?: string): Promise<InventorySample> => {
    const response = await api.post('/samples', {
      inventory_item_id: itemId,
      received_date: new Date(date).toISOString(),
      notes: notes,
    });
    return mapDtoToInventorySample(response.data);
  },

  updateSample: async (
    id: string,
    data: { date?: string; notes?: string; is_qa_passed?: boolean | null }
  ): Promise<InventorySample> => {
    const response = await api.put(`/samples/${id}`, {
      received_date: data.date ? new Date(data.date).toISOString() : undefined,
      notes: data.notes,
      is_qa_passed: data.is_qa_passed,
    });
    return mapDtoToInventorySample(response.data);
  },
};
